module.exports = __webpack_public_path__ + "img/background-Blue.91fcfaad.png";